import React, { useContext } from 'react';
import { ButtonIconRound } from '.';
import { TimeContext } from '../../context/time';

const TimeRangeNavigator: React.FC = () => {
  const timeContext = useContext(TimeContext);

  return (
    <div className="flex items-center justify-between">
      <div className="flex-none flex">
        <ButtonIconRound
          name="arrow"
          iconSize={30}
          iconViewBox={30}
          onClick={timeContext.prev}
          className="rotate-180"
        />
        <ButtonIconRound
          name="arrow"
          iconSize={30}
          iconViewBox={30}
          className="ml2"
          onClick={timeContext.next}
          disable={timeContext.isCurrentRange}
        />
      </div>
      <div className="f7 ph2 mv0 flex-auto truncate">{timeContext.formattedRange}</div>
    </div>
  );
};

export default TimeRangeNavigator;
